import { render, staticRenderFns } from "./inc_attribute.vue?vue&type=template&id=5fbbc5b8"
import script from "./inc_attribute.vue?vue&type=script&lang=js"
export * from "./inc_attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports